import { ORGANIZATION } from './index';
import { Action } from '../action';
import { OrganizationInfo } from '@shared/core';

export class OrganizationHydrateAction implements Action {
	readonly type = ORGANIZATION.HYDRATE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class OrganizationHydrateSuccessAction implements Action {
	readonly type = ORGANIZATION.HYDRATE_SUCCESS;
	constructor(
		public payload: OrganizationInfo[],
		public correlationId?: number
	) {}
}

export class OrganizationHydrateFailureAction implements Action {
	readonly type = ORGANIZATION.HYDRATE_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}
